import * as Types from '../../__generated_types__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UserFreeTicketQueryVariables = Types.Exact<{
  xTenantId: Types.Scalars['ID']['input'];
  userProfileId: Types.Scalars['ID']['input'];
}>;


export type UserFreeTicketQuery = { __typename?: 'Query', userFreeTicket?: { __typename?: 'PagedUserProfileFreeTicket', data?: Array<{ __typename?: 'UserProfileFreeTicket', id?: string | null, freeTicketsTemplateId?: string | null, bonusTemplateId?: string | null, status?: Types.UserProfileFreeTicketStatus | null } | null> | null } | null };


export const UserFreeTicketDocument = gql`
    query UserFreeTicket($xTenantId: ID!, $userProfileId: ID!) {
  userFreeTicket(xTenantID: $xTenantId, userProfileId: $userProfileId) {
    data {
      id
      freeTicketsTemplateId
      bonusTemplateId
      status
    }
  }
}
    `;

/**
 * __useUserFreeTicketQuery__
 *
 * To run a query within a React component, call `useUserFreeTicketQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFreeTicketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFreeTicketQuery({
 *   variables: {
 *      xTenantId: // value for 'xTenantId'
 *      userProfileId: // value for 'userProfileId'
 *   },
 * });
 */
export function useUserFreeTicketQuery(baseOptions: Apollo.QueryHookOptions<UserFreeTicketQuery, UserFreeTicketQueryVariables> & ({ variables: UserFreeTicketQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserFreeTicketQuery, UserFreeTicketQueryVariables>(UserFreeTicketDocument, options);
      }
export function useUserFreeTicketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserFreeTicketQuery, UserFreeTicketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserFreeTicketQuery, UserFreeTicketQueryVariables>(UserFreeTicketDocument, options);
        }
export function useUserFreeTicketSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserFreeTicketQuery, UserFreeTicketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserFreeTicketQuery, UserFreeTicketQueryVariables>(UserFreeTicketDocument, options);
        }
export type UserFreeTicketQueryHookResult = ReturnType<typeof useUserFreeTicketQuery>;
export type UserFreeTicketLazyQueryHookResult = ReturnType<typeof useUserFreeTicketLazyQuery>;
export type UserFreeTicketSuspenseQueryHookResult = ReturnType<typeof useUserFreeTicketSuspenseQuery>;
export type UserFreeTicketQueryResult = Apollo.QueryResult<UserFreeTicketQuery, UserFreeTicketQueryVariables>;